import $fetch from '../../../fetch';
import { API_BASE_URL, parseResponseData } from '../../utils';
import {
  AcceptInviteParams,
  SendOtpParams,
  VerifyOtpParams,
} from './auth.requests.types';
import { default as authResponseSchemas } from './auth.responses.schemas';

const BASE_SERVICE_URL = `${API_BASE_URL}/auth` as const;

export async function acceptInvite(params: AcceptInviteParams) {
  const response = await $fetch(`${BASE_SERVICE_URL}/acceptInvite`, {
    method: 'POST',
    body: JSON.stringify(params),
  });

  const data = parseResponseData(response, authResponseSchemas.acceptInvite);

  return data;
}

export async function sendOtp(params: SendOtpParams) {
  const response = await $fetch(`${BASE_SERVICE_URL}/sendOtp`, {
    method: 'POST',
    body: JSON.stringify(params),
  });

  const data = parseResponseData(response, authResponseSchemas.sendOtp);
  return data;
}

export async function verifyOtp(params: VerifyOtpParams) {
  const response = await $fetch(`${BASE_SERVICE_URL}/verifyOtp`, {
    method: 'POST',
    body: JSON.stringify(params),
  });

  const data = parseResponseData(response, authResponseSchemas.verifyOtp);
  return data;
}
